import * as d3 from "d3";
import {
    addGridlines,
    contextMenu,
    createAxis,
    createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    generateDownloadData,
    inrFormatter, numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam, checkbox, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 500,
        margin: { top: 40, right: 280, bottom: 100, left: 120 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const axisTickFontPx = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var axisfontsize = axisTickFontPx + 'px'
    var axislabelfontsize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + 'px'
    var axislabelfontcolor = chart.axisLabelFontColor
    var axisfontcolor = chart.axisFontColor
    const chartForGrid = Object.assign({}, chart, { width: chartWidth, height: chartHeight })

    // console.log("decl", chart, divId, vizName, filterParam)
// append the svg object to the body of the page
    var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
        .append("svg")
        .attr("width", chartWidth + chartMargin.left + chartMargin.right)
        .attr("height", chartHeight + chartMargin.top + chartMargin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform",
            "translate(" + chartMargin.left + "," + chartMargin.top + ")");

//Read the data
//     var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(res => {

        // axios({ url: '/json/country_gdp_le_pop.json', baseURL: '', method: 'GET' }).then(res => {
//        d3.json("country_gdp_le_pop.json",  function(data) {
        let data = resData

        // ---------------------------//
        //       AXIS  AND SCALE      //
        // ---------------------------//
        console.log("Data", data, d3.max(data, function (d) {
            return d.metric2
        }))
        // var dataValue=data.map((d) => {
        //     return d[chart.x1DataFieldName]
        // }).sort(d3.ascending);
        // var range = [width,0]
        // Add X axis
        var x = createAxis(chart.x1D3ScaleType).domain(data.map((d) => {
            return d[chart.x1DataFieldName]
        }).sort(d3.ascending))
            .range([0, chartWidth])
            .padding(0.2);
        svg.append("g")
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(d3.axisBottom(x))
            .selectAll("text")
            .style("text-anchor", "end") // Optional: adjust the text anchor
            .attr("dx", "-0.5em")
            .attr("dy", "0.5em")
            .attr('font-size', axisfontsize)
            .attr('fill', axisfontcolor)
            .attr("transform", "rotate(-45)");

        // Add X axis label:
        svg.append("text")
        .attr("transform", "translate(" + (chartWidth / 2) + " ," + (chartHeight + chartMargin.top + 35) + ")")
        .style("text-anchor", "middle")
        .attr("font-size", axislabelfontsize)
        .style('fill', axislabelfontcolor)
        .text(chart.x1AxisDisplayName);

        // var minValue=d3.min(data,d=>{return d.metric1});
        // var maxValue=d3.max(data, d => {return d.metric1})
        // var value1=[d3.max(data, d => {return d.metric1}),d3.min(data,d=>{return d.metric1})];
        // var range1 =[0,chart.height]
        // Add Y axis
    var y = createAxis(chart.y1D3ScaleType)
        .domain([
            d3.min(data, d => d.metric1),
            d3.max(data, d => d.metric1)
        ])
        .nice()
        .range([chartHeight, 0]);
    if (gridflag === true) {
            addGridlines(svg, x, y, chartForGrid);
        }

        svg.append("g")
            .call(d3.axisLeft(y).tickFormat(numberFormat))
            .attr('font-size', axisfontsize)
            // .attr('fill', axisfontcolor);

        // Add Y axis label:
        svg.append("text")
            .attr("transform", "rotate(-90)")
            .attr("x", -chartHeight / 2)
            .attr("y",  chartMargin.left - 80)
            .attr("dy", "-8em")
            .style("text-anchor", "middle")
            .attr("font-size", axislabelfontsize)
            .style('fill', axislabelfontcolor)
            .text(chart.y1AxisDisplayName)

        // Add a scale for bubble size
        var z = d3.scaleSqrt()
            .domain(d3.extent(data, d => {
                return d.metric3
            })) //find min and max population value
            .range([2, 30]);

        // Add a scale for bubble color
        let dim1_names = [...new Set(data.map(obj => obj.dim1_name))]
        var myColor = d3.scaleOrdinal()
            .domain(dim1_names)
            .range(d3.schemeSet2);


        // ---------------------------//
        //      TOOLTIP               //
        // ---------------------------//

        const tooltip = createTooltip(divId);


        // What to do when one group is hovered
        var highlight = function (d) {
            // reduce opacity of all groups
            d3.selectAll(".bubbles").style("opacity", .05)
            // expect the one that is hovered
            d3.selectAll("." + d).style("opacity", 0.5)
        }

        // And when it is not hovered anymore
        var noHighlight = function () {
            d3.selectAll(".bubbles").style("opacity", 0.5)
        }


        // ---------------------------//
        //       CIRCLES              //
        // ---------------------------//

        // Add dots
        svg.append('g')
            .selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("class", function (d) {
                return "bubbles " + d.dim1_name
            })
            .attr("cx", function (d) {
                return x(d[chart.x1DataFieldName]);
            })
            .attr("cy", function (d) {
                return y(d.metric1);
            })
            .attr("r", function (d) {
                return z(d.metric3);
            })
            // .attr("r", 7  )
            .style("fill", function (d) {
                return myColor(d.dim1_name);
            })
            .attr("cx", d => x(d[chart.x1DataFieldName]) + x.bandwidth() / 2)
            .attr("cy", d => y(d.metric1))
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x2AxisDisplayName + ": " + d.dim1_name + "<br>" +
                        chart.x2MetricTooltip + ": " + d.dim2_name + "<br>" +
                        chart.x1MetricTooltip + ": " + inrFormatter(d.metric1) + "<br>" +
                        chart.y1MetricTooltip + ": " + inrFormatter(d.metric2) + "<br>" +
                        chart.y2MetricTooltip + ": " + inrFormatter(d.metric3) + "<br>"
                });
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {
                console.log(d)
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]:[d.dim2_name]
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            })


        // ---------------------------//
        //       LEGEND              //
        // ---------------------------//

        // Add legend: circles
        // var valuesToShow = [10000000, 100000000, 1000000000]
        var valuesToShow = [d3.min(data, function (d) {
            return d.metric3
        }),
            // d3.median(data,function(d){return d.metric3}),
            d3.max(data, function (d) {
                return d.metric3
            })]
        var xCircle = chartWidth + chartMargin.left
        var xLabel = chartWidth + chartMargin.left
        svg
            .selectAll("legend")
            .data(valuesToShow)
            .enter()
            .append("circle")
            .attr("cx", xCircle)
            .attr("cy", function (d) {
                return chartHeight - 100 - z(d)
            })
            .attr("r", function (d) {
                return z(d)
            })
            .style("fill", "none")
            .attr("stroke", "black")

        // Add legend: segments
        svg
            .selectAll("legend")
            .data(valuesToShow)
            .enter()
            .append("line")
            .attr('x1', function (d) {
                return xCircle + z(d)
            })
            .attr('x2', xLabel)
            .attr('y1', function (d) {
                return chartHeight - 100 - z(d)
            })
            .attr('y2', function (d) {
                return chartHeight - 100 - z(d)
            })
            .attr('stroke', 'black')
            .style('stroke-dasharray', ('2,2'))

        // Add legend: labels
        svg
            .selectAll("legend")
            .data(valuesToShow)
            .enter()
            .append("text")
            .attr('x', xLabel)
            .attr('y', function (d) {
                return chartHeight - 100 - z(d)
            })
            .text(function (d) {
                return inrFormatter(d)
            })
            .style("font-size", axisfontsize)
            .attr('alignment-baseline', 'middle')

        // Legend title
        svg.append("text")
            .attr('x', xCircle + 10)
            .attr("y", chartHeight - 100 + 30)
            .text(chart.y2AxisDisplayName)
            .attr("text-anchor", "middle")
            .attr("font-size", axislabelfontsize)
            .style("fill", axislabelfontcolor)

        // Add one dot in the legend for each name.
        var legendRowSize = 30
        var allgroups = dim1_names
        svg.selectAll("myrect")
            .data(allgroups)
            .enter()
            .append("circle")
            .attr("cx", xCircle)
            .attr("cy", function (d, i) {
                return 10 + i * (legendRowSize + 5)
            }) // 100 is where the first dot appears. 25 is the distance between dots
            .attr("r", 7)
            .style("fill", function (d) {
                return myColor(d)
            })
            .style("opacity", 0.5)
            .on("mouseover", highlight)
            .on("mouseleave", noHighlight)

        // Add labels beside legend dots
        svg.selectAll("mylabels")
            .data(allgroups)
            .enter()
            .append("text")
            .attr("x", xCircle + legendRowSize * .8)
            .attr("y", function (d, i) {
                return i * (legendRowSize + 5) + (legendRowSize / 2)
            }) // 100 is where the first dot appears. 25 is the distance between dots
            .style("fill", function (d) {
                return myColor(d)
            })
            .text(function (d) {
                return d
            })
            .attr("text-anchor", "left")
            .style("alignment-baseline", "middle")
            .style("font-size", axisfontsize)
            .on("mouseover", highlight)
            .on("mouseleave", noHighlight)
    // })

}
